import { Component, ViewChild, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { NotificationService } from '../_services/notification.service';
import { SettingsService } from '../_services/settings.service';
import { Router } from '@angular/router';
import { filter, take } from 'rxjs/operators';
import { StorageService } from '../_services/storage.service';
import { ConfigService } from '../_services/config.service';
import { NotificationRequestDto } from '../_services/notification.dto';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrl: './app.component.css',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AppComponent implements OnInit{
  title = 'SynthIA';

  constructor(
    private notificationService: NotificationService,
    private router: Router,
    private settingsService:SettingsService,
    private storageService:StorageService,
    private configService:ConfigService
  ) {}

  isPreprod = false;
  isFormVisible = false;
  incidentType = '';
  incidentDescription = '';

  toggleForm(): void {
    this.isFormVisible = !this.isFormVisible;
  }

  submitIncident(): void {

    if (!this.incidentType || !this.incidentDescription.trim()) {
      alert('Veuillez remplir tous les champs avant d\'envoyer.');
      return;
    }

    const incidentRequest: NotificationRequestDto = {
      type: parseInt(this.incidentType),
      demande: this.incidentDescription,
      url: window.location.href 
    };

    this.notificationService.notifEvol(incidentRequest).subscribe({
      next: () => {
        this.notificationService.addNotification({'type':'success', 'message':"Votre demande a été transmise au support"})
        this.resetForm();
      },
      error: (error) => {
        this.notificationService.addNotification({'type':'alert', 'message':"Une erreur s'est produite lors de votre demande de support."})
      }
    });
  }
  resetForm(): void {
    this.incidentType = '';
    this.incidentDescription = '';
    this.isFormVisible = false;
  }

  isOnSpecificPage(): boolean {
    const hiddenPages = ['/login', '/lostpassword', '/first-login', '/admin'];
    return hiddenPages.includes(this.router.url);
  }

ngOnInit(): void {
  this.storageService.user$
    .pipe(
      filter(user => !!user),
      take(1)
    )
    .subscribe(() => {
      this.settingsService.loadSettings().subscribe();
    });
    
    if (this.configService.getExecEnv() == "preprod"){
      this.isPreprod = true;
    };


  }

}
